import React, { useEffect } from 'react';
import SecondResultScreenComponent from '../ExamResult/SecondScreen';
// import ThridScreenComponent from './ThridScreen';
export default function FirstScreenResult(props) {
  const {
    ExamData,
    setReload,
    choose, setChoose,
    AnswerArray, setAnswerArray,
    ResultData, Rank, StudentDetails, QuestionsDataValue
  } = props;
  const [QuestionsSolved, setQuestionsSolved] = React.useState(0);
  const [correctAnswer, setcorrectAnswer] = React.useState(0);
  const [QuestionsEditMode1, setQuestionsEditMode1] = React.useState(false);
  const [ArrayIndex, setArrayIndex] = React.useState("");
  const [QuestionsData, setQuestionsData] = React.useState(
    // JSON.parse(ExamData.meta.exam_question_block_text)
    QuestionsDataValue
  );
  const [QuestionsEditMode, setQuestionsEditMode] = React.useState(true);
  const [QuestionsEditData, setQuestionsEditData] = React.useState(
    QuestionsDataValue["item-0"]
    // JSON.parse(ExamData.meta.exam_question_block_text)["item-0"]
  );
  const [QuestionsEditKey, setQuestionsEditKey] = React.useState("item-0");

  const CalculateQuestionSolved = () => {
    var correct = 0;
    var solved = 0;
    for (let i = 0; i < AnswerArray.length; i++) {
      if (AnswerArray[i].correct_answer == AnswerArray[i].answerChoosen) {
        correct++
      }
      if (AnswerArray[i].solved == 1)
        solved++
      setQuestionsSolved(solved)
      setcorrectAnswer(correct)
    }
  }
  useEffect(() => {
    CalculateQuestionSolved()
  }, [])
  return (
    <div
      style={{padding:"0px", height: "95vh", overflowY: "scroll" }}
    >
      {/* Questions Solved: {QuestionsSolved} */}
      <h1>{ExamData.title.rendered}</h1>
      {/* <b>Exam Date: {ResultData.meta.exam_date_results}</b> */}
      <div style={{ padding: "10px" }} className='d-sm-block d-none'>
        <span style={{
          border: "2px solid black",
          margin: "10px", width: "20px", height: "20px", backgroundColor: "#66fc03"
        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;Correct_Answer
        <span style={{
          border: "2px solid black",
          margin: "10px", width: "20px", height: "20px", backgroundColor: "#f00"
        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;Wrong_Answer
        <span style={{
          border: "2px solid black",
          margin: "10px", width: "20px", height: "20px", backgroundColor: "#f7e686"
        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;Unsolved_Question

      </div>
      <div style={{ padding: "10px" }} className='d-sm-none d-block'>
        <span style={{
          border: "2px solid black",
          margin: "10px", width: "20px", height: "20px", backgroundColor: "#66fc03"
        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;Correct_Answer<br />
        <span style={{
          border: "2px solid black",
          margin: "10px", width: "20px", height: "20px", backgroundColor: "#f00"
        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;Wrong_Answer<br />
        <span style={{
          border: "2px solid black",
          margin: "10px", width: "20px", height: "20px", backgroundColor: "#f7e686"
        }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;Unsolved_Question

      </div>

      <div>
        <div className="row">
          <div className="col-8">Total Questions</div>
          <div className="col-4">{Object.keys(QuestionsData).length}</div>
        </div>
        <div className="row row-data">
          <div className="col-8">Total Attempt</div>
          <div className="col-4">{QuestionsSolved}</div>
        </div>
        <div className="row row-data">
          <div className="col-8">Total Correct</div>
          <div className="col-4">{correctAnswer}</div>
        </div>
        <div className="row row-data">
          <div className="col-8">Percentage Obtained</div>
          <div className="col-4">{(correctAnswer / AnswerArray.length * 100).toFixed(2)}%</div>
        </div>
        <div className="row row-data">
          <div className="col-8">Rank</div>
          <div className="col-4">{Rank}</div>
        </div>
        {AnswerArray.map((item, index) => (
          <div key={index}>
            <SecondResultScreenComponent
              oneQuestionData={Object.values(QuestionsData)[index]}
              AnswerArray={AnswerArray}
              ArrayIndex={index}
            />
          </div>
        ))}
      </div>
    </div >
  )
}
